<!-- src/components/Help.vue -->
<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import TreeItem from '../components/Help/TreeViewItem.vue';

const helpContent = {
  items: [
    {
      id: 'getting-started',
      title: 'Getting Started',
      children: [
        {
          id: 'quick-start',
          title: 'Quick Start Guide',
          content: 'This is the quick start guide content...'
        },
        {
          id: 'installation',
          title: 'Installation',
          content: 'Installation instructions go here...'
        }
      ]
    },
    {
      id: 'trading-basics',
      title: 'Trading Basics',
      children: [
        {
          id: 'charts',
          title: 'Understanding Charts',
          content: 'Learn about different chart types...'
        },
        {
          id: 'orders',
          title: 'Order Types',
          children: [
            {
              id: 'market-orders',
              title: 'Market Orders',
              content: 'Market order explanation...'
            },
            {
              id: 'limit-orders',
              title: 'Limit Orders',
              content: 'Limit order explanation...'
            }
          ]
        }
      ]
    }
  ]
};

const route = useRoute();

const findContent = (items: any[], path: string[]): any => {
  if (path.length === 0) return null;

  const currentId = path[0];
  const item = items.find(item => item.id === currentId);

  if (!item) return null;

  if (path.length === 1) {
    return item;
  }

  return findContent(item.children || [], path.slice(1));
};

const currentPath = computed(() => {
  return route.path.split('/').filter(segment => segment !== 'help');
});

const currentContent = computed(() => {
  const content = findContent(helpContent.items, currentPath.value);
  return content?.content || 'Please select a topic';
});

const breadcrumbs = computed(() => {
  const result: { title: string; path: string }[] = [];
  return result;
  /*
  const result: { title: string; path: string }[] = [];
  let currentItems = helpContent.items;
  let currentPath = '/help';

  for (const segment of currentPath.value) {
    const item = currentItems.find(item => item.id === segment);
    if (item) {
      currentPath += `/${segment}`;
      result.push({
        title: item.title,
        path: currentPath
      });
      currentItems = item.children || [];
    }
  }

  return result;
  */
});
</script>

<template>
  <div class="flex flex-col gap-4 p-4">
    <!-- Breadcrumb navigation -->
    <div class="flex items-center gap-2 text-sm text-gray-600">
      <router-link to="/help" class="hover:text-blue-600">Help</router-link>
      <template v-for="(crumb, index) in breadcrumbs" :key="index">
        <span>&gt;</span>
        <router-link :to="crumb.path" class="hover:text-blue-600">
          {{ crumb.title }}
        </router-link>
      </template>
    </div>

    <div class="flex gap-6">
      <!-- Tree menu -->
      <div class="w-64 border-r pr-4">
        <ul class="space-y-2">
          <TreeItem
              v-for="item in helpContent.items"
              :key="item.id"
              :item="item"
              :path="[]"
          />
        </ul>
      </div>

      <!-- Content area -->
      <div class="flex-grow">
        <div class="prose">
          {{ currentContent }}
        </div>
      </div>
    </div>
  </div>
</template>